module.exports = __webpack_public_path__ + "img/RoundHere_logo_152x80.80f7a85d.png";